import { toast } from "react-toastify";
import { apiUrl } from "../../Constants/Constants";

export const payReservedModalLogic = (
  { fetchWithToken, getInfo, onLogout, closeFinalModal },
  modalContext
) => {
  const {
    openUpModal,
    description,
    confirmTitle,
    payloadConfirm,
    toDo,
    closeModal,
  } = modalContext;

  const payAccountByWallet = (selectedAccounts, amount) => {
    openUpModal();
    confirmTitle("تایید پرداخت");
    let texter = (
      <>
        آیا مطمئن هستید که می‌خواهید مبلغ
        <strong style={{ padding: "5px", display: "inline-block" }}>
          {amount.toLocaleString("fa-IR")} تومان
        </strong>
        را از کیف پول خود پرداخت کنید ؟
      </>
    );
    description(texter);
    toDo(() => payWithWalletOnActiveNew);
    payloadConfirm(selectedAccounts);
  };

  const payWithWalletOnActiveNew = (accounts) => {
    const former = new FormData();
    former.append("selectedAccounts", accounts.reserveId);

    fetchWithToken(
      apiUrl + "user/pay-new-account-wallet",
      {
        method: "POST",
      },
      former
    ).then((data) => {
      if (data.status === "200") {
        // window.location.replace(data.data);

        toast.success("با موفقیت پرداخت گردید.");

        closeFinalModal("payReserved");
        closeModal("confirm");
        getInfo();
      }

      if (data.status === "401") {
        onLogout();
      }
    });
  };

  const fetchPaymentUrl = (accounts) => {
    const former = new FormData();
    former.append("selectedAccounts", accounts.reserveId);

    fetchWithToken(
      apiUrl + "user/create-payment-new-account",
      {
        method: "POST",
      },
      former
    ).then((data) => {
      if (data.status === "200") {
        toast.info("در حال انتقال به دروازه پرداخت...");
        window.location.replace(data.data);
      }

      if (data.status === "401") {
        onLogout();
      }
    });
  };

  return {
    fetchPaymentUrl,
    payAccountByWallet,
  };
};
